import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { isTruthy } from '@sama/js-core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map } from 'rxjs/operators';

interface Category {
  color: string;
  percentage: number;
  tooltip?: string;
}

@Component({
  selector: 'h3-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatTooltip],
})
export class ProgressBarComponent extends DirectiveSuperclass {
  @Input() categories: Category[] = [];
  @Input() isLoading = false;

  tooltip$ = this.getInput$('categories').pipe(
    map((categories: Category[]) =>
      categories
        .map((c) => c.tooltip)
        .filter(isTruthy)
        .join('\n'),
    ),
  );
}
